// @flow

import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useTheme } from '@mui/material/styles';
import { log } from '../../utils/jsUtils';
import { CopyToClipboard } from 'react-copy-to-clipboard';

import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputAdornment from '@mui/material/InputAdornment';

import FileCopy from '@mui/icons-material/FileCopy';

import ContentContainer from '../SharedComponents/ContentContainer';
import SPBackend from '../../services/SPBackend';
import { setSnackMessage } from '../../reduxStore/modules/common/actions';
import { selectUser } from '../../reduxStore/modules/user';

import { createClasses } from '../../utils/stylesUtils';
import referralsContentStyles from './Styles/ReferralsContent.Style';

const ReferralsContent = () => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const user = useSelector(selectUser);
  const classes = createClasses(referralsContentStyles, theme);

  const [referralShortUrl, setReferralShortUrl] = useState('');
  const [referralAccount, setReferralAccount] = useState(null);
  const [referralLanguage, setReferralLanguage] = useState('');

  const loadCampaign = () => {
    window.VL.load(process.env.REACT_APP_VIRAL_LOOPS_CAMPAIGN_ID, { autoLoadWidgets: !0 });
  };

  const setupWidgets = () => {
    const campaign = window.VL.instances[process.env.REACT_APP_VIRAL_LOOPS_CAMPAIGN_ID];

    if (!campaign) return;
    const widgets = campaign.widgets.getAll();

    if (typeof widgets !== 'undefined' && widgets.length > 0) {
      widgets.map(widget => widget.show());
    }
  };

  useEffect(() => {
    if (user !== null) {
      SPBackend.getReferralLink(user)
        .then((response) => {
          log('[getReferralLink] response: ', response);
          const { referralAccount } = response.data;
          setReferralAccount(referralAccount);
          setReferralShortUrl(`https://${referralAccount.ReferralShortUrl}`);
          setReferralLanguage(`Hey, I'm excited to share an invite to Neo: the most human customer experience ever made.
I love the product, and I think you will too!

Just click here to sign up for a free trial: https://${referralAccount.ReferralShortUrl}

With my invite, you skip the waiting list, and you'll get a free trial instantly to text with your audience and try all the features 🙂`
          );
        })
        .catch((e) => {
          log('[getReferralLink] e: ', e);
          dispatch(setSnackMessage({
            message: 'Problem retrieving your link. Contact us if this error persists',
            level: 'error',
            duration: 5000
          }));
        });
    }
  }, [user, dispatch]);

  const onCopy = () => {
    log('[onCopy] copied!');
    dispatch(setSnackMessage({
      message: 'Copied to your clipboard!',
      level: 'success',
      duration: 2000
    }));
  };

  log('[render] referralAccount: ', referralAccount);

  return (
    <ContentContainer
      hasSubheader={true}
      sx={classes.tableContainer}
    >
      <Box sx={classes.kpiCtr}>
        <Paper
          sx={classes.kpiDiv}
          elevation={2}
        >
          <Typography
            sx={classes.kpiCaption}
            variant='body1'
          >Visited links</Typography>
          <Typography
            sx={classes.kpiNb}
            variant='h1'
          >{referralAccount ? referralAccount.VisitsCount : 0}</Typography>
        </Paper>
        <Paper
          sx={classes.kpiDiv}
          elevation={2}
        >
          <Typography
            sx={classes.kpiCaption}
            variant='body1'
          >Subscribed</Typography>
          <Typography
            sx={classes.kpiNb}
            variant='h1'
          >{referralAccount && referralAccount.Referees ? referralAccount.Referees.length : 0}</Typography>
        </Paper>
        <Paper
          sx={classes.kpiDiv}
          elevation={2}
        >
          <Typography
            sx={classes.kpiCaption}
            variant='body1'
          >Total earned</Typography>
          <Typography
            sx={classes.kpiNb}
            variant='h1'
          >$0</Typography>
        </Paper>
      </Box>

      <Box sx={classes.blockquoteCtr}>
        <blockquote className='tweet-this'>
          <p>Neo is now invite-only, so you decide who should benefit from Neo next!</p>
          <p>Share invites to Neo by SMS through the invite link and get a 20% commission in credits or cash.</p>
        </blockquote>
      </Box>
      <Box sx={classes.refPageCtr}>
      
        <Typography variant='h4'>Share invite & link</Typography>
        <Box component="form" sx={classes.referralLanguageTextForm}>
          <TextField
            sx={classes.referralLanguageTextField}
            id="outlined-basic"
            multiline
            onChange={(e) => setReferralLanguage(e.target.value)}
            rows={8}
            value={referralLanguage}
            variant="outlined"
          />
          <CopyToClipboard
            onCopy={onCopy}
            text={referralLanguage}
          >
            <IconButton
              aria-label="Copy link"
              edge="end"
            >
              <FileCopy />
            </IconButton>
          </CopyToClipboard>
        </Box>

        <Typography variant='h4'>Share link</Typography>

        <FormControl
          sx={classes.textField}
          variant="filled"
        >
          <OutlinedInput
            sx={classes.outlinedLinkUrl}
            endAdornment={
              <InputAdornment position="end">
                <CopyToClipboard
                  onCopy={onCopy}
                  text={referralShortUrl}
                >
                  <IconButton
                    aria-label="Copy link"
                    edge="end"
                  >
                    <FileCopy />
                  </IconButton>
                </CopyToClipboard>
              </InputAdornment>
            }
            id="filled-adornment-password"
            readOnly
            type={'text'}
            value={referralShortUrl}
          />
        </FormControl>

      </Box>
    </ContentContainer>
  );
};

export default ReferralsContent;

